// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"89":"f99f42a0","294":"0d52e389","777":"1f617ef8","953":"e004f482"}[chunkId] + ".css";
};